// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"49492ae5","343":"b566b72b","378":"dc03f4d3","488":"c05a5c89","583":"1bd47e33","647":"7f675989","685":"ebdfca31","834":"6b42b31e"}[chunkId] + ".chunk.js";
};